import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as accountLoginSessionActions from "../actions/account_login_session_actions";
import * as accountLoginSessionTypes from "../types/account_sessions_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfAccountsSessions(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_ACCOUNT_SESSIONS, action.payload);
    if (res.status === 200) {
      yield put(accountLoginSessionActions.getListOfLoginSessionsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.datau.message);
      yield put(accountLoginSessionActions.getListOfLoginSessionsFailure(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountLoginSessionActions.getListOfLoginSessionsFailure(e));
  }
}

export default function* accountLoginSessionsSaga() {
  yield takeLatest(accountLoginSessionTypes.getListOfLoginSessions.REQUEST, getListOfAccountsSessions);
}
